import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlbums2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAlbums2"><Path fillRule="evenodd" clipRule="evenodd" d="M21.2031 11L19.3281 21H4.66827L2.79327 11H21.2031ZM19.9982 9H3.9982V7H19.9982V9ZM18.9982 5H4.9982V3H18.9982V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAlbums2;
